import { render, staticRenderFns } from "./Ravintoloille.vue?vue&type=template&id=7a6b3c89&scoped=true&"
import script from "./Ravintoloille.vue?vue&type=script&lang=js&"
export * from "./Ravintoloille.vue?vue&type=script&lang=js&"
import style0 from "./Ravintoloille.vue?vue&type=style&index=0&id=7a6b3c89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6b3c89",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
